<template>
  <modal
    name="confirm-remove-outfit"
    transition="pop-out"
    :width="modalWidth"
    :height="250"
    @before-open="beforeOpen"
  >
    <div class="box">
      <div class="box-part" id="bp-left">
        <div class="partition" id="partition-register">
          <div class="partition-title">
            <p class="maintext">Remove outfit?</p>
            <p class="subtext">Removing an outfit <b>cannot</b> be undone</p>
          </div>
          <div class="custom-form-elements">
            <div class="text-center">
              <b-button
                variant="link"
                size="lg"
                class="mr-2 mt-2 custom-form-btn link-btn"
                @click="closeModal"
              >
                Cancel
              </b-button>

              <b-button
                variant="danger"
                size="lg"
                class="mt-2 custom-form-btn btn-raised"
                @click="submitRemoveOutfit"
              >
                Remove
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapActions } from "vuex";

const MODAL_WIDTH = 656;

export default {
  name: "RemoveOutfitModal",

  data() {
    return {
      modalWidth: MODAL_WIDTH,
      wardrobeId: null,
      wardrobeOutfitId: null,
    };
  },

  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  methods: {
    ...mapActions(["destroyWardrobeOutfit"]),

    beforeOpen(event) {
      this.wardrobeId = event.params.wardrobeId;
      this.wardrobeOutfitId = event.params.wardrobeOutfitId;
    },

    submitRemoveOutfit() {
      const payload = {
        wardrobeId: this.wardrobeId,
        wardrobeOutfitId: this.wardrobeOutfitId,
      };

      this.destroyWardrobeOutfit(payload);
      this.closeModal();
    },

    closeModal() {
      this.$nextTick(() => this.$modal.hide("confirm-remove-outfit"));
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_custom_form.scss";

$background_color: #404142;

.box {
  background: white;
  overflow: hidden;
  max-width: 656px;
  width: 100%;
  height: 250px;
  border-radius: 2px;
  box-sizing: border-box;
  box-shadow: 0 0 40px black;
  border-top: 3px solid $alizarin;
  color: $primary-blue;

  .partition {
    width: 100%;
    height: 100%;

    .partition-title {
      box-sizing: border-box;
      padding: 30px;
      width: 100%;
      text-align: center;
      letter-spacing: 1px;
      font-size: 20px;
      font-weight: 300;

      .maintext {
        font-weight: 400;
      }
      .subtext {
        color: #8b8c8d;
        font-size: 13px;
        font-style: italic;
      }
    }

    .link-btn {
      color: $primary-blue;
    }
  }
}

.pop-out-enter-active,
.pop-out-leave-active {
  transition: all 0.5s;
}

.pop-out-enter,
.pop-out-leave-active {
  opacity: 0;
  transform: translateY(24px);
}
</style>



// WEBPACK FOOTER //
// src/components/wardrobe/outfits/RemoveOutfitModal.vue